var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WorkIconButton',_vm._g(_vm._b({attrs:{"icon":_vm.icon},scopedSlots:_vm._u([(_vm.internalTooltip)?{key:"tooltip",fn:function(){return [_vm._v(" "+_vm._s(_vm.internalTooltip)+" ")]},proxy:true}:null],null,true)},'WorkIconButton',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }